import React from "react";

import { KyruusEmbeddedSearchProps } from "./kyruus-embedded-search";
import "./kyruus-embedded-search.scss";

const KyruusInputPlaceholder: React.FC<KyruusEmbeddedSearchProps> = ({ content }: KyruusEmbeddedSearchProps) => {
  const location_label = content?.location_label ?? "";
  const location_radius = content?.location_search_radius ?? "";
  const showLocationClass = content?.show_location_field ? " ky-show-location" : "";

  return (
    <>
      <div className="kyruus-div placeholder">
        <div className="ky-search kyruus">
          <div className="ky-search-bar kyruus-config-primary-color kyruus-config-font">
            <div className="ky-search-form">
              <div className={`ky-input-search-terms${showLocationClass}`}>
                <label className="ky-label-m ky-mb-xs ky-d-block placeholder">{content?.search_label}</label>
                <div className="twitter-typeahead typeahead-placeholder">
                  <input
                    disabled={true}
                    readOnly={true}
                    className="ky-br-s ky-full-width tt-input input-placeholder"
                    placeholder={content?.search_box_placeholder_text ?? ""}
                  />
                </div>
              </div>
              <div className={`ky-right-input-group${showLocationClass}`}>
                {content?.show_location_field && (
                  <div className="ky-input-location">
                    {content?.show_location_field && content?.location_label && (
                      <label className="ky-label-m ky-mb-xs ky-d-block placeholder" htmlFor="location" id="ky-location-label">
                        {location_label}
                      </label>
                    )}
                    {content?.show_location_field && !content?.location_label && (
                      <label className="ky-label-m ky-mb-xs ky-d-block" htmlFor="location" id="ky-location-label">
                        Within {location_radius} miles of:
                      </label>
                    )}
                    <input
                      disabled={true}
                      readOnly={true}
                      className="ky-br-s ky-full-width input-placeholder"
                      id="location"
                      name="location"
                      type="text"
                      placeholder={content?.location_box_placeholder_message ?? ""}
                      aria-labelledby="ky-location-label"
                    />
                  </div>
                )}
                <div className={`ky-submit-search placeholder${showLocationClass}`}>
                  <label className="ky-m ky-mb-xs ky-d-block submit-label-placeholder" htmlFor="submit">
                    Submit
                  </label>
                  <button
                    id="submit"
                    type="submit"
                    className="ky-button placeholder-btn ky-btn-l ky-full-width ky-btn-positive kyruus-config-secondary-color"
                    aria-label="Search"
                  >
                    <span className="ky-icon-search icon-search ky-fs-l placeholder"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KyruusInputPlaceholder;
